import { Component, effect, linkedSignal, model, ModelSignal, WritableSignal } from '@angular/core';
import { SelectedTimeReportTypeEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import { UiDateRangePickerComponent } from '@app/shared/ui/date-range-picker/ui-date-range-picker.component';
import { ProffeoUiDateRange } from '@app/shared/ui/types/date-picker.types';
import { DateRange } from '../../../types/models/reports/new/date-range';

@Component({
  selector: 'date-range-selector',
  imports: [UiDateRangePickerComponent],
  templateUrl: './date-range-selector.component.html',
  styleUrl: './date-range-selector.component.scss'
})
export class DateRangeSelectorComponent {
  protected readonly SelectedTimeReportTypeEnum = SelectedTimeReportTypeEnum;

  protected readonly rangeValue: WritableSignal<ProffeoUiDateRange> = linkedSignal(() => ({
    start: this.selectedDateRange()?.start ?? null,
    end: this.selectedDateRange()?.end ?? null
  }));

  public readonly selectedTimeMode: ModelSignal<SelectedTimeReportTypeEnum> = model<SelectedTimeReportTypeEnum>();
  public readonly selectedDateRange: ModelSignal<DateRange> = model<DateRange>();

  public constructor() {
    effect(() => {
      const range = this.rangeValue();
      if (!range.start || !range.end) {
        return;
      }

      this.selectedTimeMode.set(SelectedTimeReportTypeEnum.RANGE);

      const current = this.selectedDateRange();
      if (
        (current?.start?.getTime() ?? null) !== range.start.getTime() ||
        (current?.end?.getTime() ?? null) !== range.end.getTime()
      ) {
        this.selectedDateRange.set({ start: range.start, end: range.end });
      }
    });
  }
}
